/**
 * Core TypeScript types for Safe transaction handling
 * Ported from safe-tx-hashes-util bash script
 */
/**
 * Safe transaction operation type
 * @see https://github.com/safe-global/safe-smart-account/blob/main/contracts/libraries/Enum.sol
 */
export var Operation;
(function (Operation) {
    Operation[Operation["Call"] = 0] = "Call";
    Operation[Operation["DelegateCall"] = 1] = "DelegateCall";
})(Operation || (Operation = {}));
//# sourceMappingURL=types.js.map